export default __webpack_public_path__ + "static/media/backpage.5f7ad8a3.svg";